import React from 'react';
import WarmupPattern from '../../pages/EmployeePortal/Warmups/WarmupPattern';
import { midiToName } from '../../services/warmupStepPlan';
import { swapCandidates } from '../../services/warmupRoutineModel';
import { PURPOSE_LABEL, mmss } from './warmupFormat';

/**
 * The routine as rows — tap a row to play it, Swap for an alternative of the
 * same purpose, Skip to drop it.
 *
 * Split out of WarmupPlayer on 2026-09-04 (Lesson Dashboard I1 phase 0), markup
 * unchanged. I1 puts this in the right column at 520px while the deck moves to
 * the conducting strip; today it renders exactly where it always did.
 *
 * `compact` hides the pattern graphic on the current row — that is the lesson's
 * narrow column, and it is a SIZE-GATED omission of decoration, not of
 * information: the meta line (start key → top key · bpm · length) is always
 * rendered at every width.
 */
const WarmupRoutineList = ({ wp, compact = false }) => {
	const { catalog, routine, items, byId, current, isActive, swapping, setSwapping, playItem, onSkip, onSwap } = wp;

	return (
		<ol className="wp__list">
			{items.map((item, i) => {
				const ex = byId.get(item.exerciseId);
				if (!ex) return null;
				const isCurrent = i === current;
				return (
					<li key={`${item.slot}-${item.exerciseId}`} className={`wp__row${isCurrent ? ' is-current' : ''}${isCurrent && isActive ? ' is-playing' : ''}`}>
						<button type="button" className="wp__rowmain" onClick={() => playItem(i)} aria-label={`Play ${ex.name}`}>
							<span className="wp__purpose">{PURPOSE_LABEL[item.purpose] || item.purpose}</span>
							<span className="wp__name">
								<span className="wp__id">{ex.id}</span> {ex.name}
							</span>
							<span className="wp__meta">
								{midiToName(item.startTonic)} → {midiToName(item.topTonic)}
								{item.aboveBand ? ' (above the band)' : ''} · {item.bpm} bpm · {mmss(item.seconds)}
							</span>
						</button>
						{isCurrent && !compact && (
							<div className="wp__pattern">
								<WarmupPattern exercise={ex} />
							</div>
						)}
						<span className="wp__rowactions">
							<button type="button" className="wp__mini" title={`Swap ${ex.name}`} onClick={() => setSwapping(swapping === i ? null : i)}>
								Swap
							</button>
							<button type="button" className="wp__mini" title={`Skip ${ex.name}`} onClick={() => onSkip(i)}>
								Skip
							</button>
						</span>
						{swapping === i && (
							<ul className="wp__picker" aria-label={`Alternatives for ${ex.name}`}>
								{swapCandidates(routine, i, catalog)
									.filter(({ ex: alt }) => alt.id !== ex.id)
									.map(({ ex: alt, tier }) => (
										<li key={alt.id}>
											<button type="button" className="wp__pick" onClick={() => onSwap(i, alt.id)}>
												<span className="wp__id">{alt.id}</span> {alt.name}
												{tier !== 'exact' && <span className="wp__tier">{tier}</span>}
											</button>
										</li>
									))}
							</ul>
						)}
					</li>
				);
			})}
		</ol>
	);
};

export default WarmupRoutineList;
